import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';

import { PERIOD_SELECTION_ACTIONS, MAX_REPORT_PERIOD_IN_DAYS } from './constants';

const isPeriodValid = (startDate, endDate) => differenceInCalendarDays(endDate, startDate) <= MAX_REPORT_PERIOD_IN_DAYS;

export const periodSelectionInitialState = {
  startPeriod: new Date(),
  endPeriod: new Date(),
  isDataValid: true,
  isDataDirty: false,
};

const periodSelection = (state = periodSelectionInitialState, action) => {
  switch (action.type) {
    case PERIOD_SELECTION_ACTIONS.SET_PERIOD_START:
      return {
        ...state,
        startPeriod: action.payload,
        isDataDirty: true,
        isDataValid: isPeriodValid(action.payload, state.endPeriod),
      };
    case PERIOD_SELECTION_ACTIONS.SET_CALENDAR_VIEW:
      return {
        ...state,
        isCalendarView: action.payload,
      };
    case PERIOD_SELECTION_ACTIONS.SET_PERIOD_END:
      return {
        ...state,
        endPeriod: action.payload,
        isDataDirty: true,
        isDataValid: isPeriodValid(state.startPeriod, action.payload),
      };
    default:
      return state;
  }
};

export default periodSelection;
